import React, {useState, useEffect} from 'react';
import {
  StyleSheet,
  View,
  ImageSourcePropType,
  TouchableOpacity,
  StyleProp,
  ViewStyle,
  Text,
  Image,
} from 'react-native';
import {colors} from 'src/assets';
import {stringDateFullDynamicFormat} from 'src/utils/date';

export type HeaderProps = {
  containerStyle?: StyleProp<ViewStyle>;
  name?: string | ImageSourcePropType;
  image?: ImageSourcePropType | undefined;
  createdAt?: string | undefined;
};

export const Header: React.FC<HeaderProps> = ({
  containerStyle,
  image,
  name,
  createdAt,
}) => {
  const [formatterCreatedAt, setFormatterCreatedAt] = useState<
    string | undefined
  >();
  useEffect(() => {
    setFormatterCreatedAt(
      createdAt ? stringDateFullDynamicFormat(createdAt) : undefined,
    );
  }, [createdAt]);
  return (
    <View style={[styles.container, containerStyle]}>
      {image ? <Image source={image} style={styles.image} /> : null}
      {name ? <Text style={styles.name}>{`${name}さん`}</Text> : name}
      {formatterCreatedAt ? (
        <Text style={styles.time}>{formatterCreatedAt}</Text>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  image: {
    width: 24,
    height: 24,
    borderRadius: 12,
  },
  name: {
    flex: 1,
    marginLeft: 8,
    fontSize: 12,
    fontWeight: '600',
    color: colors.chokuGray,
  },
  time: {
    marginLeft: 8,
    fontSize: 12,
    fontWeight: '600',
    color: colors.chokuGray,
  },
});
